import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export function maxFileUploadSize(files:FileList): ValidatorFn {

    return (control: AbstractControl):ValidationErrors|null => {
        var maxFileUploadSize = false;
        Array.from(files).forEach((file: any) => {
            if (file.size > 6291456){  //6 MB
                maxFileUploadSize = true;
            }
        });
        if(maxFileUploadSize)
            return {'maxFileUploadSize': 'File size exceeds the maximum limit of 6MB. Please upload a smaller file.'}
        return null!;
    }
}